import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import dayjs from "dayjs";
import moment from "moment";
import { fetchShiftType } from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";

const { TextArea } = Input;

const AddShiftScheduleModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { shiftType, loading } = useSelector((state) => state.dropdown);
  const { personnelFolders, fldLoading } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  async function fetchShiftTypeData() {
    dispatch(fetchShiftType());
  }
  async function fetchPersonnelData() {
    dispatch(fetchPersonnelFolders());
  }

  const onFinish = async (data) => { 
    if (!formData?.ssStartDate) {
      toast.error("Please add start date");
      return;
    }
    if (!formData?.ssEndDate) {
      toast.error("Please add end date");
      return;
    }
    
    const res = await dispatch(
      save({
        ssId: prodd?.ssId ? prodd?.ssId : null,
        ssShiftId: formData?.ssShiftId,
        ssPpId: formData?.ssPpId,
        ssStartDate: formData?.ssStartDate, 
        ssEndDate:formData?.ssEndDate,
        ssDescription: formData?.ssDescription,

        url: "shift/saveShiftSchedule.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  // useEffect(() => {
  //   if (prodd) {
  //     form.setFieldsValue(prodd);
  //   } else {
  //     form.setFieldsValue({});
  //   }
  // }, [prodd, form]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.stName}` : "Add shift schedule details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item 
            className=""
            label={<span>Shift Type</span>}
            rules={[
              {
                required: true,
                message: "Please select Shift Type",
              },
            ]}
          >
            <Select
              name="ssShiftId"
              value={formData?.ssShiftId}
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                shiftType?.length > 0 &&
                shiftType?.map((item) => ({
                  value: item?.stId,
                  label: item?.stName,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ssShiftId");
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchShiftTypeData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Personnel</span>}
            rules={[
              {
                required: true,
                message: "Please select Personnel",
              },
            ]}
          >
            <Select
              name="ssPpId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: 
                    item?.ppFullname +
                    " - " +
                    item?.coDeptname +
                    " - " +
                    item?.coSectionname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ssPpId");
              }}
              value={formData?.ppFullname}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchPersonnelData();
              }}
              dropdownRender={(menu) => (
                <>
                  {fldLoading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="Start Date"
          >
            <DatePicker
              name="ssStartDate"
              className="input"
              placeholder={
                formData?.ssStartDate
                  ? moment(formData.ssStartDate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.ssStartDate ? dayjs(formData.ssStartDate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "ssStartDate");
              }}
            />
          </Form.Item>
         
          <Form.Item
            rules={[
              {
                required: false,
                message: "Field is required",
              },
            ]}
            label="End Date"
          >
            <DatePicker
              name="ssEndDate"
              className="input"
              placeholder={
                formData?.ssEndDate
                  ? moment(formData.ssEndDate)?.format("DD-MM-YYYY")
                  : "Select Date"
              }
              value={formData?.ssEndDate ? dayjs(formData.ssEndDate) : null}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                onMonthChange(value, "ssEndDate");
              }}
            />
          </Form.Item>
         

          
          <Form.Item
            label="Shift Description"
            rules={[
              {
                required: true,
                message: "Enter Shift Description",
              },
            ]}
          >
            <TextArea
              required
              rows={6}
              name="ssDescription"
              onChange={onChange}
              value={formData?.ssDescription}
              className="input"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddShiftScheduleModal;
